
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoySpecialPurposeIce as ObiSimplifiedBuoySpecialPurposeIceElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-special-purpose-ice.js';
 
 
 

 
 export const ObiSimplifiedBuoySpecialPurposeIce = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-special-purpose-ice',
   elementClass: ObiSimplifiedBuoySpecialPurposeIceElement,
   events: {
     
   }
  });
 
 